'use client';

import clsx from 'clsx';

interface StickyFooterProps extends React.HTMLAttributes<HTMLDivElement> {}

import './StickyFooter.scss';

const StickyFooter = ({ children, className, ...rest }: StickyFooterProps) => {
  return (
    <div className={clsx('sticky-button', className)} {...rest}>
      {children}
    </div>
  );
};

export default StickyFooter;
